// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/display_configuration.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message knop.ui.v1.model.DisplayConfiguration
 */
export class DisplayConfiguration extends Message<DisplayConfiguration> {
  /**
   * @generated from field: uint32 display_order = 1;
   */
  displayOrder = 0;

  /**
   * @generated from field: bool visible_by_default = 2;
   */
  visibleByDefault = false;

  constructor(data?: PartialMessage<DisplayConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.DisplayConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "display_order", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "visible_by_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DisplayConfiguration {
    return new DisplayConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DisplayConfiguration {
    return new DisplayConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DisplayConfiguration {
    return new DisplayConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: DisplayConfiguration | PlainMessage<DisplayConfiguration> | undefined, b: DisplayConfiguration | PlainMessage<DisplayConfiguration> | undefined): boolean {
    return proto3.util.equals(DisplayConfiguration, a, b);
  }
}

